import { Institute } from '@nw/shared/config';

export const getInstituteDetailsFromInstituteId = (
    instituteId: string,
    institutes: Institute[]
): Institute | undefined => institutes.find((institute) => institute.institute_id === instituteId);

export const getInstituteIdFromInstituteName = (
    instituteName: string,
    institutes: Institute[]
): string | undefined =>
    institutes.find((institute) => institute.institute_name === instituteName)
        ?.institute_id;

export const getInstituteNameFromInstituteId = (
    instituteId: string,
    institutes: Institute[]
): string | undefined =>
    institutes.find((institute) => institute.institute_id === instituteId)
        ?.institute_name;

